import { downloadJson } from '../utils/downloadJson'
import { useBrowserBackSentinel } from '../utils/useBrowserBackSentinel'

/**
 * Non-prod JSON inspector + exporter for an eligibility check. Pretty-prints
 * the payload (271 `result` + collection recommendation) with "Copy All"
 * (clipboard) and "Download" (.json file) actions.
 *
 * Used by the success slideout and the manual-check view so test fixtures can
 * be captured straight from the deployed dev/staging site — the older
 * `import.meta.env.DEV` gate evaluated false in built bundles and hid it there.
 * Self-gates on `open`, so callers can render it unconditionally.
 */
export default function RawJsonModal({ open, onClose, data, filenameBase }: {
  open: boolean
  onClose: () => void
  data: unknown
  filenameBase: string
}) {
  // Its own nested level on top of whatever opened it (#231) — otherwise a
  // browser Back while this is up falls through to the slideout's sentinel and
  // closes the whole check instead of just the inspector. Must run before the
  // `!open` return so the hook order is stable across opens/closes.
  useBrowserBackSentinel(open, onClose)

  if (!open) return null
  const json = JSON.stringify(data, null, 2)
  return (
    <div className="dev-raw-json-overlay" onClick={onClose}>
      <div className="dev-raw-json-modal" onClick={e => e.stopPropagation()}>
        <div className="dev-raw-json-modal__header">
          <span className="dev-raw-json-modal__title">Eligibility Check JSON (de-identified)</span>
          <button
            className="dev-raw-json-modal__copy"
            onClick={() => navigator.clipboard.writeText(json)}
          >
            Copy All
          </button>
          <button
            className="dev-raw-json-modal__copy"
            style={{ marginLeft: 0 }}
            onClick={() => downloadJson(filenameBase, data)}
          >
            Download
          </button>
          <button className="dev-raw-json-modal__close" onClick={onClose}>
            &times;
          </button>
        </div>
        <pre className="dev-raw-json-modal__content">{json}</pre>
      </div>
    </div>
  )
}
